import { ContentPaste, PeopleAlt, Settings } from '@mui/icons-material';
import { Chip, Grid, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { AppModels, AppState, appUrl, projectPageSlice, projectSelector } from 'cdx-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { appStore } from '../../store';
import { AppItem, NoCompanyIcon } from '../AppItems';
import { MasterViewPage } from '../MasterPage';
import { ProjectQuotes } from '../quote/ProjectQuotes';
import { SimLinkTabs } from '../utils/SimTabs';
import { ProjectContacts } from './ProjectContacts';
import { ProjectParamters } from './ProjectParamters';
import { ProjectQuicaillerie } from './ProjectQuicaillerie';

export enum ProjectSection {
    quotes = 1,
    contacts = 0,
    quincaillerie = 3,
    settings = 4,
}
/*
export const ProjectPage = (props: { section: ProjectSection; }) => {
    const params = useParams();
    return <MasterViewPage>
        <MainViewLoader
            modelId={parseInt(params.id ?? '')}
            selector={projectSelector}
            path={'project/' + params.id}
            onModelLoaded={project => {
                appStore.dispatch(documentSlice.actions.setTitle(project.name));
            }}>
            <LoadedProject id={parseInt(params.id ?? '')} section={props.section} />
        </MainViewLoader>
    </MasterViewPage>;
};
*/


export const ProjectPage = (props: { section?: ProjectSection; }) => {
    const params = useParams();
    const project = useSelector((state: AppState) => projectSelector.selectById(state, params.id ?? '0'));
    //const projectData = useSelector((state: AppState) => projectDataSelector.selectById(state, params.id ?? '0'));

    React.useEffect(() => {
        if (project) {
            appStore.dispatch(projectPageSlice.actions.updateProject(project));
        }
    }, []);


    if (!project) return <></>;

    const getTabs = () => {
        const tabs = [
            {
                icon: <PeopleAlt />,
                label: 'Intervenants',
                content: <ProjectContacts />,
                to: appUrl('projectContacts', { id: project.id })
            },
            {
                icon: <ContentPaste />,
                label: 'Soumissions',
                content: <ProjectQuotes projectId={project.id} />,
                to: appUrl('projectQuotes', { id: project.id })
            },
            {
                icon: NoCompanyIcon,
                label: 'Fournisseurs',
                content: <ProjectSuppliers />,
                to: appUrl('projectQuotes', { id: project.id })
            }
        ];
        tabs.push({
            icon: <Settings />,
            label: 'Quicaillerie',
            content: <ProjectQuicaillerie />,
            to: appUrl('projectQuincaillerie', { id: project.id })
        });
        tabs.push({
            icon: <Settings />,
            label: 'Paramètres',
            content: <ProjectParamters />,
            to: appUrl('projectSettings', { id: project.id })
        });
        return tabs;
    };

    return <MasterViewPage>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography noWrap variant='h4'>{project.name}</Typography>
                <Stack direction='row' spacing={2}>
                    <Typography noWrap variant='subtitle1' component='span'><Chip label={project.code} /></Typography>
                    {project.customerCompanyId && <AppItem mode='compact' type={AppModels.companies} id={project.customerCompanyId} />}
                    {project.mainContactId && <AppItem mode='compact' type={AppModels.contacts} id={project.mainContactId} />}
                    {project.locationId && <AppItem mode='compact' type={AppModels.locations} id={project.locationId} />}
                </Stack>
            </Grid>
            <Grid item xs={12}>
                <SimLinkTabs
                    sx={{ backgroundColor: 'white', p: 2 }}
                    defaultTab={props.section ?? 0}
                    tabs={getTabs()} />
            </Grid>
        </Grid>
    </MasterViewPage>;
};

const ProjectSuppliers = () => {
    return <></>;
};
